import type {
  TCalendarSingleProps,
} from "@/ui/components/form/Calendar/Calendar.config";
import { getDateString } from "libs/utils/misc/src/dates";

type TUseAvailableDateCalendarProps = {
  availableDates: Iterable<string>;
  onSelect: (date: string) => void;
  selectedDate?: string;
};

export const useAvailableDateCalendar = ({
  availableDates,
  onSelect,
  selectedDate,
}: TUseAvailableDateCalendarProps) => {
  const availableDateSet = new Set(availableDates);
  const selected = selectedDate
    ? new Date(`${selectedDate}T00:00:00`)
    : undefined;

  return {
    defaultMonth: selected,
    disabled: (date: Date) => {
      const dateString = getDateString(date);

      return !dateString || !availableDateSet.has(dateString);
    },
    selected,
    onSelect: (date: Date | undefined) => {
      const dateString = getDateString(date);

      if (!dateString || !availableDateSet.has(dateString)) {
        return;
      }

      onSelect(dateString);
    },
  } satisfies Omit<TCalendarSingleProps, "mode">;
};
